import PropTypes from 'prop-types';
import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@mui/material/styles';
import { getDirhamSymbolSizePx } from 'utils/currency';
import DirhamSymbol from './DirhamSymbol';

export default function CurrencyInputAdornment({ size }) {
  const theme = useTheme();
  const iconPx = size ?? getDirhamSymbolSizePx('body2', theme);

  return (
    <InputAdornment position="start" sx={{ mr: 0.25, maxHeight: 'none' }}>
      <DirhamSymbol size={iconPx} />
    </InputAdornment>
  );
}

CurrencyInputAdornment.propTypes = {
  size: PropTypes.number
};
